此文件夹放的是所有正在使用的图片

其他文件夹的图片引用已经转到这里

以后维护更新图片可以专注此文件夹
